import { USER_KEY } from '../constants'

export default () => {
  const { id } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return id
}
